import { useCallback } from 'react';

import type { NavItemConfigInternal } from '../../../common/types';
import { useUserMenuDataShapes } from '../../user-state/user-menu-data-shapes-provider';
import { useItemsAndShortcuts } from '../index';

export function useItemProperties() {
	const { allItems } = useItemsAndShortcuts();
	const { userMenuData, visibleItemMenuIds } = useUserMenuDataShapes();

	const getItemProperties = useCallback(
		(itemMenuId: string) => {
			const item: NavItemConfigInternal = allItems?.[itemMenuId];
			if (!item) {
				return null;
			}

			return {
				index: userMenuData.findIndex((item) => item.menuId === itemMenuId) ?? -1,
				isReorderable: item?.isReorderable ?? true,
				isHideable: item?.isHideable ?? true,
				isVisible: visibleItemMenuIds.includes(itemMenuId),
			};
		},
		[allItems, userMenuData, visibleItemMenuIds],
	);

	return {
		getItemProperties,
	};
}
